/* RESPONSIBLE TEAM: team-inbox */
import { helper } from '@ember/component/helper';

export function UnlessIsTyping(cb: [(params: KeyboardEvent) => void]) {
  return (params: KeyboardEvent) => {
    // Use composedPath to pierce Shadow DOM boundaries. The React teammate-app
    // renders inside a Shadow DOM, so event.target gets retargeted to the shadow
    // host element. composedPath()[0] returns the true originating element.
    let target = (params.composedPath?.()?.[0] ?? params.target) as Element;
    let invalidTagNames = ['input', 'textarea'];

    if (
      invalidTagNames.includes(target.tagName?.toLowerCase()) ||
      (target.getAttribute && target.getAttribute('contentEditable') === 'true')
    ) {
      return;
    }
    cb[0]?.(params);
  };
}

let unlessIsTypingHelper = helper<{
  Args: {
    Positional: [(params: KeyboardEvent) => void];
  };
  Return: (params: KeyboardEvent) => any;
}>(UnlessIsTyping);
export default unlessIsTypingHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'unless-is-typing': typeof unlessIsTypingHelper;
  }
}
